<avn-section-breadcrumb [sections]="section?.tagsStructure"></avn-section-breadcrumb>

<div class="each-section" [style.grid-template-columns]="gridCssColumns$ | async">
  <div *ngFor="let board of boards$ | async; trackBy: boardTrackFn" [avnBackground]="{ cssProp: '--surface-background', shade: 600 }">
    <amp-site-monitoring-board [board]="board"> </amp-site-monitoring-board>
  </div>
</div>
